var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "lbv-leak-list animated fadeIn roundedCard" },
    [
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-lg-12" },
          [
            _c(
              "b-card",
              [
                _c("div", { staticClass: "col-lg-12 leak-list-header" }, [
                  _c("span", { staticClass: "lbv-page-title" }, [
                    _vm._v("Add Role to Api\n            "),
                    _c(
                      "form",
                      {
                        staticClass: "roleDropdown",
                        on: {
                          submit: function ($event) {
                            $event.preventDefault()
                          },
                        },
                      },
                      [
                        _c(
                          "b-form-select",
                          {
                            staticClass: "full-width",
                            attrs: { id: "statusFilter" },
                            nativeOn: {
                              change: function ($event) {
                                return _vm.onChange.apply(null, arguments)
                              },
                            },
                            model: {
                              value: _vm.roleSelection,
                              callback: function ($$v) {
                                _vm.roleSelection = $$v
                              },
                              expression: "roleSelection",
                            },
                          },
                          _vm._l(_vm.APIs, function (api) {
                            return _c(
                              "option",
                              _vm._b(
                                {
                                  key: api.apiID,
                                  domProps: { value: api.apiID },
                                },
                                "option",
                                _vm.$attrs,
                                false
                              ),
                              [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(api.apiName) +
                                    "\n                "
                                ),
                              ]
                            )
                          }),
                          0
                        ),
                      ],
                      1
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("b-table", {
                  attrs: {
                    striped: "",
                    hover: "",
                    items: _vm.userRoles,
                    fields: _vm.fields,
                    "per-page": _vm.perPage,
                    "current-page": _vm.currentPage,
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "id",
                      fn: function (data) {
                        return [
                          _c("b-form-checkbox", {
                            attrs: {
                              plain: true,
                              value: "data.item.id",
                              "unchecked-value": "0",
                              value: data.item.id,
                            },
                            nativeOn: {
                              change: function ($event) {
                                return _vm.clickHandler.apply(null, arguments)
                              },
                            },
                            model: {
                              value: _vm.checkedAPIs,
                              callback: function ($$v) {
                                _vm.checkedAPIs = $$v
                              },
                              expression: "checkedAPIs",
                            },
                          }),
                        ]
                      },
                    },
                  ]),
                }),
              ],
              1
            ),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }